/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { DictionaryItemDto, GlobalDictionaryDto } from './dictionary-item.dto';
import { DictionaryItemMapper, GlobalDictionaryItemMapper } from './dictionary-item.mapper';

@Injectable()
export class DictionaryRestService extends AbstractRestService {

  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(code: string): Observable<DictionaryItemDto[]> {
    return this.httpGet(`${this.bp}/dictionaries/${code}`, arrayOf(DictionaryItemMapper));
  }

  getGlobal(): Observable<GlobalDictionaryDto> {
    return this.httpGet(`${this.bp}/dictionaries/`, GlobalDictionaryItemMapper);
  }
}
